import React from "react";
import { X } from "lucide-react";

/**
 * Full-screen modal that lists big quick-pick options.
 * options: [{ id, label, accent? }]
 */
export default function CodeQuickPick({ open, title, options, onPick, onClose, hint }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/80 z-50 grid place-items-center p-6"
      onClick={onClose}
      data-testid="code-quickpick"
    >
      <div
        className="bg-[#0e1a30] border border-[#1f2c47] rounded-2xl w-full max-w-2xl p-6 sm:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-5">
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-sky-300">Quick Pick</div>
            <div className="text-2xl sm:text-3xl font-black tracking-tight text-white">{title}</div>
            {hint && <div className="text-xs text-slate-400 mt-1">{hint}</div>}
          </div>
          <button
            onClick={onClose}
            data-testid="quickpick-close"
            className="text-slate-400 hover:text-white p-2"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {options.map((opt) => (
            <button
              key={opt.id}
              onClick={() => onPick(opt)}
              data-testid={`pick-${opt.id}`}
              className="bg-[#152340] hover:bg-[#1d2f56] border border-[#2a3a5e] active:scale-[0.98] rounded-xl px-4 py-6 text-white text-base sm:text-lg font-bold tracking-wide transition-all"
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
